import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sym from '../components/Sym';
import Logo2 from '../components/Logo2';

/**
 * Footer del rediseño — siempre oscuro (data-dark), con columnas
 * Producto / Empresa / Legal. Aviso de privacidad y Términos apuntan a las
 * páginas legales existentes.
 */
const COLS = [
  {
    title: 'Producto',
    links: [
      { label: 'Características', to: '/caracteristicas' },
      { label: 'Seguridad', to: '/seguridad' },
      { label: 'Precios', to: '/pricing' },
    ],
  },
  {
    title: 'Empresa',
    links: [
      { label: 'Contacto', to: '/contact' },
      { label: 'Iniciar sesión', to: '/login' },
      { label: 'Prueba 15 días', to: '/register' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Aviso de privacidad', to: '/privacy-policy' },
      { label: 'Términos', to: '/terms-of-service' },
    ],
  },
];

const Footer2 = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const linkStyle = { font: "400 .95rem 'Hanken Grotesk'", color: 'var(--label-2)', cursor: 'pointer', display: 'block', padding: '5px 0' };

  return (
    <footer data-dark style={{ background: '#04070F', color: '#8595B4', padding: 'clamp(48px,6vw,72px) 0 32px', borderTop: '1px solid rgba(255,255,255,.06)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 clamp(20px,5vw,40px)', display: 'flex', flexWrap: 'wrap', gap: 40, justifyContent: 'space-between' }}>
        <div style={{ maxWidth: 320 }}>
          <div style={{ marginBottom: 16 }}>
            <Logo2 size={38} />
          </div>
          <p style={{ font: "400 1rem/1.55 'Hanken Grotesk'", color: 'var(--label-2)', margin: '0 0 16px' }}>
            El puente entre el SAT y tu equipo. Tus recibos de nómina, entregados solos.
          </p>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, font: "600 .9rem 'Hanken Grotesk'", color: '#AEBAD2' }}>
            <Sym name="public" size={18} color="#6FA0FF" />Hecho en México
          </div>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 56 }}>
          {COLS.map((col) => (
            <div key={col.title}>
              <div style={{ font: "700 .78rem 'IBM Plex Mono'", letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--footer-faint)', marginBottom: 10 }}>{col.title}</div>
              {col.links.map((l) => (
                <a key={l.label} onClick={() => navigate(l.to)} style={linkStyle}>{l.label}</a>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: '36px auto 0', padding: '20px clamp(20px,5vw,40px) 0', borderTop: '1px solid rgba(255,255,255,.06)', font: "500 .85rem 'Hanken Grotesk'", color: 'var(--footer-faint)', textAlign: 'center' }}>
        © {year} PaySlip. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Footer2;
